import Login from "./Login";
import Register from "./Register";
import Verify from "./Verify";
import ForgotPassword from "./FogrotPassword";
import { withQueryAndAnalytics } from "../routes";


const LoginWithAnalytics = withQueryAndAnalytics(Login);
const RegisterWithAnalytics = withQueryAndAnalytics(Register);
const VerifyWithAnalytics = withQueryAndAnalytics(Verify);
const ForgotPasswordWithAnalytics = withQueryAndAnalytics(ForgotPassword);

export { LoginWithAnalytics, RegisterWithAnalytics, VerifyWithAnalytics, ForgotPasswordWithAnalytics };